const filters = {
  initialValueRange: {
    min: 0,
    max: 70000000,
  },
  'Tipo de Compra': [
    {
      value: 'plataforma',
      name: 'Via Plataforma (direto c/ banco)',
      checked: false,
    },
    {
      value: 'leilao',
      name: 'Via Leiloeiros (sites externos)',
      checked: false,
    },
    {
      value: 'outros',
      name: 'Outros (sites externos)',
      checked: false,
    },
  ],
  'Tipo de Imóvel': [
    {
      value: 'Apartamento',
      name: 'Apartamento',
      checked: false,
    },
    {
      value: 'Area',
      name: 'Área',
      checked: false,
    },
    {
      value: 'Box_Garagem',
      name: 'Box garagem',
      checked: false,
    },
    {
      value: 'Casa',
      name: 'Casa',
      checked: false,
    },
    {
      value: 'Casa_Condominio',
      name: 'Casa em condomínio',
      checked: false,
    },
    {
      value: 'Chacara_Sitio',
      name: 'Chácara/Sítio',
      checked: false,
    },
    {
      value: 'Fazenda',
      name: 'Fazenda',
      checked: false,
    },
    {
      value: 'flat_hotel',
      name: 'Flat/Hotel',
      checked: false,
    },
    {
      value: 'Galpao',
      name: 'Galpão',
      checked: false,
    },
    {
      value: 'Predio',
      name: 'Prédio',
      checked: false,
    },
    {
      value: 'Sala',
      name: 'Sala',
      checked: false,
    },
    {
      value: 'Salao_Comercial',
      name: 'Salão Comercial',
      checked: false,
    },
    {
      value: 'Loja_Salao_Comercial',
      name: 'Loja/Salão comercial',
      checked: false,
    },
    {
      value: 'Lote',
      name: 'Lote',
      checked: false,
    },
    {
      value: 'Lote_Condominio',
      name: 'Lote em condomínio',
      checked: false,
    },

    {
      value: 'Outros',
      name: 'Outros',
      checked: false,
    },
  ],
  Finalidade: [
    { value: 'Residencial', name: 'Residencial', checked: false },
    { value: 'Rural', name: 'Rural', checked: false },
    { value: 'Comercial', name: 'Comercial', checked: false },
    { value: 'Incorporacao', name: 'Incorporação', checked: false },
    { value: 'Industrial', name: 'Industrial', checked: false },
    { value: 'Misto', name: 'Misto', checked: false },
    { value: 'Consultar', name: 'Indefinida', checked: false },
  ],
  'Categoria de Venda': [
    {
      value: 'venda_amigavel',
      name: 'Venda Amigável',
      checked: false,
    },
    {
      value: 'venda_judicial',
      name: 'Venda Judicial',
      checked: false,
    },
    {
      value: 'outras',
      name: 'Outras',
      checked: false,
    },
  ],
  Situação: [
    {
      value: 'Ocupado',
      name: 'Ocupado',
      checked: false,
    },
    {
      value: 'Desocupado',
      name: 'Desocupado',
      checked: false,
    },
    {
      value: 'Locado',
      name: 'Alugado',
      checked: false,
    }, // MUDADO
  ],
  'Tipo de Venda': [
    { value: 'venda_direta', name: 'Venda Direta', checked: false },
    { value: 'primeiro_leilao', name: 'Primeiro Leilão', checked: false },
    { value: 'segundo_leilao', name: 'Segundo Leilão', checked: false },
    { value: 'leilao', name: 'Leilão', checked: false },
    {
      value: 'concorrencia_publica',
      name: 'Imóvel em Disputa',
      checked: false,
    },
  ],
  Desagio: [
    { value: '30', name: 'Até 30%', checked: false },
    { value: '50', name: 'Até 50%', checked: false },
    { value: '51', name: 'Acima de 50%', checked: false },
  ],
}
export default filters
